import React, { useEffect, useState } from "react"
import { CSS_PROPERTY } from "../../cssProperties/tablet"

const BASE_STYLE: React.CSSProperties = {
  display: "flex",
  width: "calc(100% - 3rem)",
  margin: "0 0 0 0",
  verticalAlign: "center",
  height: "12rem",
  ...CSS_PROPERTY.BORER_PROPERTIES,
  padding: "2rem 2rem",
}
const TenkoTimingButton: React.FC<{
  children?: React.ReactNode
  onTouchStartEventHandler?: React.TouchEventHandler<HTMLDivElement>
  isSelected?: boolean
  selectedBackGroundColor?: string
  backGroundColor?: string
}> = ({
  children,
  onTouchStartEventHandler,
  isSelected,
  selectedBackGroundColor,
  backGroundColor,
}) => {
  const [style, setStyle] = useState({
    ...BASE_STYLE,

    backgroundColor: isSelected
      ? selectedBackGroundColor ?? CSS_PROPERTY.CARD.SELECT_COLOR
      : "white",
  })

  useEffect(() => {
    setStyle({
      ...BASE_STYLE,
      backgroundColor: isSelected
        ? selectedBackGroundColor ?? CSS_PROPERTY.CARD.SELECT_COLOR
        : backGroundColor ?? "white",
    })
  }, [backGroundColor, isSelected, selectedBackGroundColor])

  return (
    <div onTouchStart={onTouchStartEventHandler} style={style}>
      {children}
    </div>
  )
}

export default TenkoTimingButton
